export default function StreamInputDescUdpMulticast({ input }) {
  return <>UDP {input.group}:{input.port} @ {input.iface}</>;
}
